// Utils
import { openColorEyeDropper, isEyeDropperSupported } from '../../utils/color/eyedropperUtil';
import { updateDrawingToolStrokeColor } from '../../element/drawing/utils/drawingColorUtils';

// Selectors
import { getIsAnnotationModeEnabled } from '../../element/drawing/annotation/store/annotationSelector';
import { isSketchModalOpen } from '../../element/drawing/sketch/modal/sketchModalSelector';
import selectIsImageModalDrawingModeActive from '../../element/image/modal/selectIsImageModalDrawingModeActive';

// Types
import { GenericReduxThunkAction } from '../../../common/actions/actionTypes';

// Utils
import globalLogger from '../../logger';

const logger = globalLogger.createChannel('workspace.eyedropper');

/**
 * Handles eyeDropper keyboard action for annotation mode, sketch modal or image drawing mode.
 */
export const handleEyeDropperKeyboardAction = (): GenericReduxThunkAction => {
    return async (_dispatch, getState) => {
        if (!isEyeDropperSupported()) {
            logger.warn('EyeDropper API is not supported in this browser');
            return;
        }

        const state = getState();

        const isInAnnotationMode = getIsAnnotationModeEnabled(state);
        const isInSketchModal = isSketchModalOpen(state);
        const isInImageDrawingMode = selectIsImageModalDrawingModeActive(state);
        const isDrawingColorContext = isInAnnotationMode || isInSketchModal || isInImageDrawingMode;

        if (!isDrawingColorContext) {
            logger.warn('Eye dropper is only available in drawing mode when called globally');
            return;
        }

        try {
            const color = await openColorEyeDropper();
            if (!color) return;

            updateDrawingToolStrokeColor(color);
        } catch (error) {
            logger.error('Failed to use eyeDropper', error);
        }
    };
};
